import ko from "knockout";
import * as mapping from 'knockout-mapping';
import val from '../../val';
import axios from "axios";

function mapDictionaryToArray(dictionary) {
    var result = [];
    for (var key in dictionary) {
        if (dictionary.hasOwnProperty(key)) {
            result.push({ key: key, value: dictionary[key] });
        }
    }

    return result;
}

var PriceYourRoomCarpet = {
    
    init: async function(data) {
        
        data.roomMOrFt = ko.computed(function() {
            if (data.RoomSettings.UsingFeet()) {
                return 'ft';
            }
            else {
                return 'm';
            }
        })
        
       
        data.addRoomMOrFt = ko.computed(function() {
            if (data.RoomSettings.UsingFeet()) {
                return 'ft';
            }
            else {
                return 'm';
            }
        })
        
        
        // deferred will throttle the ajax requests
        ko.computed(function () {
            return ko.toJSON(data.RoomSettings);
        })
            .extend({ deferred: true })
            .subscribe(function ()
        {
            recalculatePrice();
        })
        
        data.ValidCarpetPostcode = ko.observable(false);
 
        var updatePrices = async result => {
            mapping.fromJS(result, {}, data.Pricing);
        }
        
        var recalculatePrice = async function () {
            var url = $("#addbasket").attr('data-price-url');
            
            var ajaxData = mapping.toJS(data.RoomSettings);

            try {
                var result = await axios.post(url, ajaxData);
                updatePrices(result.data);
            }
            catch(err){
                
            }
        }

        data.postcodeChanged = function(place) {
            recalculatePrice();
        };
    }
    
}

export {PriceYourRoomCarpet as default};